export const REQUEST_BUSINESS_TRIP_CREATE_PATH =
  "/requests/business-trip/create";

export const REQUEST_BUSINESS_TRIP_EDIT_PATH =
  "/requests/business-trip/edit/:id";
